import { Alert, AlertTitle, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface WidgetExceptionAlertProps {
  message?: string;
  onDeleteWidget(): void;
  onResetWidget(): void;
  title?: string;
}

export default function WidgetExceptionAlert(props: WidgetExceptionAlertProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const alertTitle = props.title ?? i18n.t("error");
  const errorMessage = props.message ?? i18n.t("error");

  return (
    <Alert severity="error" sx={{height: "100%", padding: "0 0 0 10px"}}>
      {props.title &&
        <AlertTitle>{alertTitle}</AlertTitle>
      }
      <strong>{i18n.t("widgets.errors.widget-error-steps")}</strong>
      <strong>{i18n.t("widgets.errors.additional-options")}</strong>
      <br />
      <Button
        sx={{marginTop: 1, marginRight: 1}}
        onClick={props.onDeleteWidget}
        variant="contained" color="error">
          {i18n.t("widgets.errors.delete-this-widget")}
      </Button>
      <Button 
        sx={{marginTop: 1}}
        onClick={() => props.onResetWidget() }
        variant="contained"
        color="warning">
        {i18n.t("widgets.errors.reset-this-widget")}
      </Button>
      {props.message &&
        <AlertTitle sx={{marginTop: 1}}>
          {errorMessage}
        </AlertTitle>
      }
    </Alert>
  )
}